import slick from 'slick-carousel';

$(document).ready(function () {

    if ($(".v-accueil__hashtag--galerie").length > 0) {

        $('.v-accueil__hashtag--galerie').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 10000,
            draggable: true,
            adaptiveHeight: false,
            fade: false,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
            ]
        });
    }

})
